var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-effect"},[_c('div',{staticStyle:{"position":"absolute","z-index":"9999999"},attrs:{"id":"ZoomEmbeddedApp"},on:{"click":_vm.generateSignature}},[_vm._v("Join")])])}
var staticRenderFns = []

export { render, staticRenderFns }